import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";

// Landing (#/) -> community picker (#/communities) -> BoardIQ (#/app).
// ?view=mobile / ?view=desktop forces a shell once inside the app.
createRoot(document.getElementById("root")).render(<App />);
